import React, { PropsWithChildren } from 'react';
// import { Provider } from 'react-redux';

export function StoreWrapper({ children }: PropsWithChildren) {
  // return <Provider store={null}>{children}</Provider>;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
